import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
    isLoading: false,
    alert: {
        msg: '',
        isShow: false
    },
    data: {}
};

export default {
    state,
    getters,
    actions,
    mutations
    // plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : []
};
